export * from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/customize/_layout';
export { default } from '@fhs/routing/src/routes/v2/menu/(menu)/[slug]/customize/_layout';
